module.exports = __webpack_public_path__ + "img/ues_progress bar4.a8815ee7.png";